const statusColorTheme = {
  install: function (Vue) {
    Vue.prototype.$getStatusBackgroundColor = function (status) {
      let statusTheme = getTheme(status);
      return theme[statusTheme].backgroundColor;
    };

    Vue.prototype.$getStatusTextColor = function (status) {
      let statusTheme = getTheme(status);
      return theme[statusTheme].textColor;
    };

    Vue.prototype.$getStatusThemeName = function (status) {
      return getTheme(status);
    };
  },
};

const theme = {
  blueValue: {
    textColor: "#0C5AB4",
    backgroundColor: "#E2EBF6",
  },
  purpleValue: {
    textColor: "#AA228F",
    backgroundColor: "#F5E4F1",
  },
  lilacValue: {
    textColor: "#7153D5",
    backgroundColor: "#EDE6F9",
  },
  darkGrayValue: {
    textColor: "#616161",
    backgroundColor: "#E4E7EA",
  },
  orangeValue: {
    textColor: "#BC621E",
    backgroundColor: "#FDEFE4",
  },
  redValue: {
    textColor: "#D32F2F",
    backgroundColor: "#FAE6E6",
  },
  greenValue: {
    textColor: "#658210",
    backgroundColor: "#EAF1D8",
  },
  darkTealValue: {
    textColor: "#025E76",
    backgroundColor: "#DEE8EA",
  },
  blueGrayValue: {
    textColor: "#61778C",
    backgroundColor: "#EDF0F3",
  },
  lightValue: {
    textColor: "#BEBEBE",
    backgroundColor: "",
  },
  mediumGrayValue: {
    textColor: "#989898",
    backgroundColor: "#989898",
  },
  grayValue: {
    textColor: "#616161",
    backgroundColor: "#E9E9E9",
  },
  aquaValue: {
    textColor: "#025E76",
    backgroundColor: "#E1ECEF",
  },
  lightGrayValue: {
    textColor: "#616161",
    backgroundColor: "#E0E0E0",
  },
};

const orangeValues = [
  "waitingForReview",
  "waitingForReissue",
  "needsApproval",
  "readyForPersonalization",
  // A tax payment batch that has had some money but is still owed the rest. Grouped with the
  // other "someone needs to deal with this" states so it stands out against sent (blue) and
  // cleared (green), rather than falling through to the grey default.
  "partiallyCleared",
];

const blueGrayValues = ["submitted", "sending", "invited", "sendDate"];

const blueValues = [
  "sent",
  "inProgress",
  "tsa",
  "applicationStarted",
  "upcoming",
  "active",
  "manualApproval",
];

const purpleValues = ["waitingForParticipant", "readyForFunds"];

const lilacValues = ["ira/tsa", "applicationSubmitted", "automaticApproval"];

const greenValues = [
  "complete",
  "cleared",
  "approved",
  "preApproved",
  "yes",
  "ira",
  "setUpComplete",
];

const darkTealValues = [
  "pending",
  "accountsDivision",
  "default",
  "new",
  "accepted",
];

const redValues = [
  "returned",
  "stopped",
  "denied",
  "no",
  "locked",
  "none",
  "errors",
  "rejected",
  "idVerificationDeclined",
];

const mediumGrayValues = ["notPayable"];

const grayValues = ["created"];

const lightValues = ["cancelled"];

const aquaValues = ["aqua"];

const lightGrayValues = ["unsubscribed"];

const getTheme = function (status) {
  if (orangeValues.includes(status)) return "orangeValue";
  if (redValues.includes(status)) return "redValue";
  if (lightValues.includes(status)) return "lightValue";
  if (blueGrayValues.includes(status)) return "blueGrayValue";
  if (darkTealValues.includes(status)) return "darkTealValue";
  if (greenValues.includes(status)) return "greenValue";
  if (blueValues.includes(status)) return "blueValue";
  if (purpleValues.includes(status)) return "purpleValue";
  if (lilacValues.includes(status)) return "lilacValue";
  if (mediumGrayValues.includes(status)) return "mediumGrayValue";
  if (grayValues.includes(status)) return "grayValue";
  if (aquaValues.includes(status)) return "aquaValue";
  if (lightGrayValues.includes(status)) return "lightGrayValue";

  //If the value doesn't match any option, it will apply darkGray color.
  return "darkGrayValue";
};

export default statusColorTheme;
